
  import { canSelfServeSubscription } from '@/ui/auth/auth';
  import { CenteredTitleSubtitlePage } from '@/ui/pages/subscription/CenteredTitleSubtitlePage';
  import TopTitleSubtitlePage from '@/ui/pages/subscription/TopTitleSubtitlePage.vue';

  export default {
    components: { CenteredTitleSubtitlePage, TopTitleSubtitlePage },
    setup() {
      return {
        canSelfServeSubscription,
      };
    },
  };
